import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import { Link as LinkRoute } from 'react-router-dom';
import { AppTheme } from '../styles/AppTheme';
import { AppConfig } from '../AppConfig';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
const queryString = require('query-string');

const styles = theme => ({
  root: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: 'absolute',
    right: -45,
    top: -45,
    color: 'white',
    '@media(max-width: 767px)': {
      right: -32,
      top: -32,
    },
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export class VideoDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    let videoSrc = ''
    const parsedUrl = queryString.parseUrl(this.props.videoLink)
    if(parsedUrl && parsedUrl.query && parsedUrl.query.v) {
      videoSrc = 'https://www.youtube.com/embed/' + parsedUrl.query.v + '?autoplay=true'
    }
    return (
      <Dialog
        disableBackdropClick={false}
        open={this.props.modalVisible}
        onClose={this.props.handleModal}
        aria-labelledby='form-dialog-title'
        classes={{
          paper: css(Styles.dialog),
        }}>
        {/*<DialogTitle
          id='customized-dialog-title'
          onClose={this.props.handleModal}>
        </DialogTitle>*/}
        <div className={css(Styles.dialogContent)}>
          <div className={css(Styles.videoContainer)}>
            <iframe
              allow='autoplay'
              allowFullScreen='true'
              className={css(Styles.videoContainerTile)}
              type='text/html'
              width='100%'
              height='100%'
              src={videoSrc}
              frameborder='0' />
          </div>
        </div>

      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  dialogContent: {
  },
  dialog: {
    width: '100%',
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    padding: 0,
    margin: 10,
  },
  videoContainerTile: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  videoContainer: {
    width: '100%',
    height: 0,
    position: 'relative',
    paddingBottom: '56.25%'
  }
})


// WEBPACK FOOTER //
// ./src/components/VideoDialog.js